import './styles.css';
import Badge from '@material-ui/core/Badge';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import CommentIcon from '@material-ui/icons/Comment';
import { fetchCourseNews } from 'actionCreators/course';
import { ICourse } from 'interface/course';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dateFormater } from 'utils';

interface IProps {
  courseHash: any;
  course: ICourse;
  fetchCourseNews: typeof fetchCourseNews;
}

interface IState {
  open: boolean;
}

class ResponsiveDialog extends Component<IProps, IState> {
  private anchorEl: any;
  private newsLastViewed: Date = localStorage.getItem('newsLastViewed')
    ? new Date(localStorage.getItem('newsLastViewed'))
    : null;

  constructor(props: IProps) {
    super(props);

    this.state = {
      open: false,
    };

    this.anchorEl = React.createRef();
  }

  get counter() {
    const { course } = this.props;

    let counter = 0;

    if (course.news && course.news.length) {
      if (!this.newsLastViewed) {
        counter = course.news.length;
      } else {
        course.news.forEach((item: any) => {
          let createdAt = new Date(item.created_at);
          if (this.newsLastViewed.getTime() < createdAt.getTime()) {
            counter++;
          }
        });
      }
    }

    return counter;
  }

  componentDidMount() {
    this.props.fetchCourseNews(this.props.courseHash);
  }

  handleClickOpen = () => {
    if (this.props.course.news && this.props.course.news.length) {
      this.setState({ open: true });
    }
  };

  handleClose = () => {
    let now = new Date();
    let nowFormat = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    localStorage.setItem('newsLastViewed', nowFormat);
    this.setState({ open: false });
  };

  render() {
    const { course } = this.props;
    return (
      <div className='news-root'>
        {!!course.news && !!course.news.length && (
          <div>
            <Badge
              className={`course-news red-dot ${this.counter ? '' : ' hide'}`}
              variant='dot'
              color='secondary'
              onClick={this.handleClickOpen}
            >
              <IconButton buttonRef={this.anchorEl} onClick={this.handleClickOpen}>
                <CommentIcon id='news-icon' />
              </IconButton>
            </Badge>
            <Popover
              className='news-popover'
              open={this.state.open}
              onClose={this.handleClose}
              anchorEl={this.anchorEl.current}
              elevation={2}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <DialogTitle className='news-title'>Novidades</DialogTitle>
              <DialogContent className='news-content'>
                {this.props.course.news &&
                  this.props.course.news.map((item: any, index: number) => {
                    let createdAt = new Date(item.created_at);
                    let viewClass =
                      this.newsLastViewed && this.newsLastViewed.getTime() >= createdAt.getTime() ? 'read' : '';

                    return (
                      <div className={`new-root ${viewClass}`} key={index}>
                        <div className='new-title'>
                          <Typography variant='h5' component='h2'>
                            {item.title}
                          </Typography>
                          <Typography component='small' style={{ marginLeft: '10px' }}>
                            {dateFormater(item.created_at)}
                          </Typography>
                        </div>
                        <div className='new-content' dangerouslySetInnerHTML={{ __html: item.content }}></div>
                      </div>
                    );
                  })}
              </DialogContent>
            </Popover>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  course: state.course,
});

export default connect(mapStateToProps, { fetchCourseNews })(ResponsiveDialog);
